import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_2 = { class: "p-field p-grid" }
const _hoisted_3 = { class: "p-col-12" }
const _hoisted_4 = {
  for: "newpw",
  class: "p-col-12 p-mb-2 p-md-2 p-mb-md-0"
}
const _hoisted_5 = { class: "p-col-12 p-md-10" }
const _hoisted_6 = { class: "p-field p-grid" }
const _hoisted_7 = {
  for: "newpwconfirm",
  class: "p-col-12 p-mb-2 p-md-2 p-mb-md-0"
}
const _hoisted_8 = { class: "p-col-12 p-md-10" }
const _hoisted_9 = { class: "p-field p-grid" }
const _hoisted_10 = { class: "p-col-6" }
const _hoisted_11 = { class: "p-col-6" }
const _hoisted_12 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_13 = { class: "p-field p-grid" }
const _hoisted_14 = { class: "p-col-6" }
const _hoisted_15 = { class: "p-col-6" }
const _hoisted_16 = {
  key: 2,
  class: "p-fluid"
}
const _hoisted_17 = { class: "p-field p-grid" }
const _hoisted_18 = { class: "p-col-6" }
const _hoisted_19 = { class: "p-col-6" }
const _hoisted_20 = {
  key: 3,
  class: "p-fluid"
}
const _hoisted_21 = { class: "p-field p-grid" }
const _hoisted_22 = { class: "p-col-12" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("a", {
  class: "p-p-2",
  href: "mailto:SwissFungi@wsl.ch",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-send" }),
  /*#__PURE__*/_createTextVNode(" SwissFungi@wsl.ch")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile_form = _resolveComponent("profile-form")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-d-flex p-jc-center" }, {
      title: _withCtx(() => [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('profile.title')), 1)
      ]),
      content: _withCtx(() => [
        (_openBlock(), _createBlock(_component_profile_form, {
          user: _ctx.user,
          onChangeUser: _ctx.setEditedUser,
          disabled: !_ctx.editing,
          key: _ctx.formKey
        }, null, 8, ["user", "onChangeUser", "disabled"]))
      ]),
      footer: _withCtx(() => [
        (_ctx.changingPw)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.$t('profile.set_new_pw')), 1)
                ]),
                _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('login.password_form')) + " *", 1),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_InputText, {
                    id: "newpw",
                    type: "password",
                    class: _normalizeClass(["p-inputtext-sm", {'is-primary': _ctx.pwValid}]),
                    modelValue: _ctx.pw,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pw) = $event))
                  }, null, 8, ["modelValue", "class"])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('login.password_confirm')) + " *", 1),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_InputText, {
                    id: "newpwconfirm",
                    type: "password",
                    disabled: !_ctx.pwValid,
                    class: _normalizeClass(["p-inputtext-sm", {'is-primary': _ctx.pwValid && _ctx.pwMatch}]),
                    modelValue: _ctx.pwConfirm,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pwConfirm) = $event))
                  }, null, 8, ["disabled", "modelValue", "class"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Button, {
                    class: "p-button-danger",
                    label: _ctx.$t('cancel'),
                    onClick: _ctx.cancelPw
                  }, null, 8, ["label", "onClick"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_Button, {
                    class: "p-button-success",
                    label: _ctx.$t('profile.change_pw_danger'),
                    onClick: _ctx.savePassword,
                    disabled: !_ctx.pwValid || !_ctx.pwMatch
                  }, null, 8, ["label", "onClick", "disabled"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.changingPw && !_ctx.editing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Button, {
                    class: "p-button-primary",
                    label: _ctx.$t('profile.change_pw'),
                    onClick: _ctx.editPassword
                  }, null, 8, ["label", "onClick"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_Button, {
                    class: "p-button-success",
                    label: _ctx.$t('profile.edit'),
                    onClick: _ctx.startEditing
                  }, null, 8, ["label", "onClick"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.editing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_Button, {
                    class: "p-button-danger",
                    label: _ctx.$t('cancel'),
                    onClick: _ctx.cancel
                  }, null, 8, ["label", "onClick"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_Button, {
                    class: "p-button-success",
                    label: _ctx.$t('save_changes'),
                    onClick: _ctx.saveUser
                  }, null, 8, ["label", "onClick"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.editing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.$t('login.information')), 1),
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('login.delete_acccount')) + " ", 1),
                    _hoisted_23
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Card, null, {
      content: _withCtx(() => [
        (_ctx.state === 'error')
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              severity: "error",
              closable: true
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('login.changeprofile_error')) + " ", 1),
                _hoisted_24,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.errors, (error, key) => {
                  return (_openBlock(), _createElementBlock("span", { key: key }, " '" + _toDisplayString(_ctx.$t('login.'+key)) + "' : " + _toDisplayString(error), 1))
                }), 128)),
                _hoisted_25
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}